import { render } from "./collections.vue?vue&type=template&id=363c2beb&scoped=true"
import script from "./collections.vue?vue&type=script&lang=js"
export * from "./collections.vue?vue&type=script&lang=js"

import "./collections.vue?vue&type=style&index=0&id=363c2beb&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/fundraise/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363c2beb"]])

export default __exports__